// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const PAGE_SIZES_RANGE_10_50 = [10, 20, 30, 40, 50];
export const PAGE_SIZES_RANGE_20_60 = [20, 40, 60];
